import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, ViewChild } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EmployeeListComponent } from '../employees/employee.list';
import { Employee } from '../../../model/api/administration/employee';
import { EmployeeHttpService } from '../../../services/http/administration/employee.http.service';
import { AppUtils } from '../../../common/app.utils';
import { EmployeeRoomHttpService } from '../../../services/http/administration/employee-room.http.service';
import { RoomHttpService } from '../../../services/http/administration/room.http.service';
import { EmployeeRoom } from '../../../model/api/administration/employee-room';
import { RoomListComponent } from '../rooms/room.list';
import { EmployeeRoomList } from './employee-room.list';
import { Room } from '../../../model/api/administration/room';


@Component({
    selector: 'employee-room-manage',
    templateUrl: 'employee-room.manage.html',
    styleUrls: ['employee-room.manage.scss'],
    providers: [ EmployeeRoomHttpService, RoomHttpService, EmployeeHttpService ]
})
export class EmployeeRoomManage extends GenericManage<EmployeeRoom, number> {

    @ViewChild('employeeRoomList') employeeRoomList: EmployeeRoomList;
    @ViewChild('roomListModal') roomListModal: ModalDirective;
    @ViewChild('roomList') roomList: RoomListComponent;
    @ViewChild('employeeListModal') employeeListModal: ModalDirective;
    @ViewChild('employeeList') employeeList: EmployeeListComponent;

    public filter: string = '';
    public selectedRoom: Room = null;
    public selectedEmployee: Employee = null;
    isCollapsed: boolean = true;

    constructor(public roomHttpService: RoomHttpService,
      public employeeRoomHttpService: EmployeeRoomHttpService,
      public employeeHttpService: EmployeeHttpService) {

        super();
    }

    ngAfterViewInit () {
        this.refresh();
    }

    public onRoomListCancel() {
        this.roomListModal.hide();
    }

    public onEmployeeListCancel() {
        this.employeeListModal.hide();
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));
        params.push(new Param("roomIds", AppUtils.getIdsList<Room, number>([ this.selectedRoom ])));
        params.push(new Param("employeeIds", AppUtils.getIdsList<Employee, number>([ this.selectedEmployee ])));


        this.employeeRoomList.refresh(params);
    }

    public selectRoom() {

        this.roomListModal.show();
        this.roomList.refresh(null);
    }

    public selectEmployee() {
        this.employeeListModal.show();
        this.employeeList.refresh(null);
    }

    public setSelectedRoom() {
        switch(this.viewMode) {
            case GenericManageViewMode.ItemList:
                this.selectedRoom = this.roomList.selectedItem;
                this.roomListModal.hide();
                this.refresh();
                break;
            default:
                break;
        }
    }

    public setSelectedEmployee() {
        switch(this.viewMode) {
            case GenericManageViewMode.ItemList:
                this.selectedEmployee = this.employeeList.selectedItem;
                this.employeeListModal.hide();
                this.refresh();
                break;
            default:
                break;
        }
    }

    public unselectRoom() {
        this.selectedRoom = null;
        this.refresh();
    }

    public unselectEmployee() {
        this.selectedEmployee = null;
        this.refresh();
    }


    public exportToExcel() {

         let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.employeeRoomHttpService.get(1, 1000000, 'code', 'asc', params, null).subscribe(
            (data: PagedResult<EmployeeRoom>) => {

                let options = {
                    sheetid: 'Administrare',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // let res = alasql(`SELECT id as [Id],
                //                     code as [Cod],
                //                     name as [Denumire],
                //                     divisionName as [Localitate / Judet]
                //                     INTO XLSX("Centre de cost.xlsx",?) FROM ?`,[ options, data.items ]);

            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
